var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cooperation"},[_vm._m(0),_c('img',{staticClass:"cooperationPic",attrs:{"src":require("@/assets/cooperation/coopcustomer.png")}}),_c('footerPage')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("@/assets/cooperation/coopCoop.png")}})])
}]

export { render, staticRenderFns }